import React, { useEffect, useRef } from 'react';

const DemioEmbed = ({ 
  webinarId, 
  title = "Watch the 15-minute Demo",
  subtext = "See how Buddy handles Maltese payroll and how the €450 migration gets you ready for January.",
  primaryCtaText = "Secure €450 Migration",
  primaryCtaLink = "#",
  secondaryCtaText = "Book a 1:1 Call",
  secondaryCtaLink = "#"
}) => {
  const videoRef = useRef(null);

  useEffect(() => {
    // Track when video section comes into view
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (window.gtag) {
              window.gtag('event', 'demo_video_view', {
                'event_category': 'engagement',
                'event_label': 'malta_demo'
              });
            }
          }
        });
      },
      { threshold: 0.5 }
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current);
      }
    };
  }, []);

  const handlePrimaryClick = (e) => {
    if (window.gtag) {
      window.gtag('event', 'click_secure_migration', {
        'event_category': 'conversion',
        'event_label': 'demo_section'
      });
    }
  };

  const handleSecondaryClick = (e) => {
    if (window.gtag) {
      window.gtag('event', 'click_book_call', {
        'event_category': 'conversion',
        'event_label': 'demo_section'
      });
    }
  };

  return (
    <div ref={videoRef} id="demo" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            {title}
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto">
            {subtext}
          </p>
        </div>

        <div className="mt-12">
          {webinarId ? (
            <div className="relative aspect-video bg-gray-900 rounded-lg overflow-hidden shadow-xl">
              <iframe
                src={`https://my.demio.com/iframe/${webinarId}?autoplay=1&hide_controls=0`}
                title="Buddy Payroll Demo"
                className="absolute inset-0 w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          ) : (
            <div className="relative aspect-video bg-gray-900 rounded-lg overflow-hidden shadow-xl flex items-center justify-center">
              <div className="text-center text-white">
                <div className="text-6xl mb-4">📹</div>
                <h3 className="text-xl font-semibold mb-2">Demo Video Placeholder</h3>
                <p className="text-gray-300">
                  TODO: Add Demio webinar ID to enable video
                </p>
                <p className="text-sm text-gray-400 mt-2">
                  Current webinarId: {webinarId || 'Not provided'}
                </p>
              </div>
            </div>
          )}
        </div>

        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href={primaryCtaLink}
            onClick={handlePrimaryClick}
            className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-orange-600 hover:bg-orange-700 transition duration-150 ease-in-out"
          >
            {primaryCtaText}
          </a>
          <a
            href={secondaryCtaLink}
            onClick={handleSecondaryClick}
            className="inline-flex items-center justify-center px-6 py-3 border border-orange-600 text-base font-medium rounded-md text-orange-600 bg-white hover:bg-orange-50 transition duration-150 ease-in-out"
          >
            {secondaryCtaText}
          </a>
        </div>
      </div>
    </div>
  );
};

export default DemioEmbed;

